import { useEffect, useRef } from 'react';
import Map, { Marker, NavigationControl } from 'react-map-gl/maplibre';
import mapStyle from './style';
import { Link } from 'react-router-dom';
import { getDeviceUrl } from 'util/device';
import useDevicesStore from 'store/devices';
import useAlarmsStore from 'store/alarms';
import { Tooltip } from '@thermon-platforms/thermon-ui-core';


function DevicesMap({device}) {
  const map = useRef();
  const [devicesStore] = useDevicesStore();
  const [alarmsStore] = useAlarmsStore();
  const site = device.path.length ? device.path[0] : device.model;
  const padding = 0.1;
  const long = site.coordinates?.[0];
  const lat = site.coordinates?.[1];
  const bounds = [(long - padding), (lat - padding), (long + padding), ( lat + padding)];

  if (!long || !lat) return (<></>);

  return (
    <div className="map-container">
      <Map
        ref={map}
        mapLib={import('maplibre-gl')}
        initialViewState={{
          longitude: device.model.coordinates[0],
          latitude: device.model.coordinates[1],
          zoom: 16
        }}
        maxZoom={22} // 22 is the default
        // minZoom={13}
        maxBounds={bounds}
        mapStyle={mapStyle}
      >
        {/*
          Don't bother showing controllers if the curent device is a panel or circuits if it's a controller
          Otherwise, show the current device and immediate children
        */}
        {[device.model, ...(device.model.type == 'Panel' || device.model.type == 'Controller' ? [] : device.model.children)].map(child =>
          <Marker
            longitude={child.coordinates[0]}
            latitude={child.coordinates[1]}
            anchor="bottom"
            key={`map-marker-${child.type}-${child.id}`}
          >
            <Link
              to={getDeviceUrl(devicesStore.shallowDevices.get(child.id))}
              data-tooltip-content={`${child.name}`}
              data-tooltip-id="map-marker-tooltip"
            >
              {/* This is a really stupid way to grab status. We'll need to improve this to make more deliberate
                  use of device status on the model or alarms.
              */}
              <span className={`
                device-icon ${child.type.toLowerCase()} ${JSON.stringify(alarmsStore.alarms).includes(child.id) ? 'alert' : ''}
              `}></span>
            </Link>
          </Marker>
        )}
        <NavigationControl position="top-left" />
      </Map>
      <Tooltip id="map-marker-tooltip" place="top" />
    </div>
  );
}

export default DevicesMap;
